/**
 * product-media-gallery.liquid ファイルの画像左右ボタン処理
 */
(() => {
  function init(root) {
    const prevBtn = root.querySelector('[data-main-media-prev]');
    const nextBtn = root.querySelector('[data-main-media-next]');
    if (!prevBtn || !nextBtn) return;

    const galleryEl = root.closest('media-gallery') || root;

    const getSlides = () =>
      Array.from(galleryEl.querySelectorAll('ul.product__media-list > li.product__media-item'));

    const getVisibleSlides = () =>
      getSlides().filter((li) => !li.classList.contains('is-hidden'));

    const getActiveIndex = (slides) => {
      const idx = slides.findIndex((li) => li.classList.contains('is-active'));
      return idx >= 0 ? idx : 0;
    };

    const findThumbButtonByMediaId = (mediaId) => {
      const thumbItem = galleryEl.querySelector(
        `.thumbnail-list__item[data-target="${CSS.escape(mediaId)}"]`
      );
      return thumbItem ? thumbItem.querySelector('button.thumbnail') : null;
    };

    const go = (direction) => {
      const slides = getVisibleSlides();
      if (slides.length <= 1) return;

      const currentIndex = getActiveIndex(slides);
      const nextIndex =
        direction === 'next'
          ? (currentIndex + 1) % slides.length
          : (currentIndex - 1 + slides.length) % slides.length;

      const targetSlide = slides[nextIndex];
      const mediaId = targetSlide.getAttribute('data-media-id');
      if (!mediaId) return;

      const thumbBtn = findThumbButtonByMediaId(mediaId);
      if (thumbBtn) {
        thumbBtn.click();
      } else {
        if (typeof galleryEl.setActiveMedia === 'function') {
          galleryEl.setActiveMedia(mediaId, true);
        }
      }
    };

    prevBtn.addEventListener('click', () => go('prev'));
    nextBtn.addEventListener('click', () => go('next'));
  }

  function boot() {
    document.querySelectorAll('media-gallery').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();